"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* ========================================================================
    Application main script
 ========================================================================== */
const uikit_1 = __importDefault(require("uikit"));
const uikit_icons_1 = __importDefault(require("uikit/dist/js/uikit-icons"));
const swiper_1 = __importStar(require("swiper"));
require("swiper/css");
require("swiper/scss/effect-fade");
require("swiper/css/autoplay");
const util_1 = require("~modules/util");
const navbar_1 = require("~modules/navbar");
const link_to_phone_1 = require("~modules/link-to-phone");
const scroll_1 = require("~modules/scroll");
const loading_1 = require("~modules/loading");
// Loads the Icon plugin
uikit_1.default.use(uikit_icons_1.default);
// configure Swiper to use modules
swiper_1.default.use([swiper_1.EffectFade, swiper_1.Autoplay]);
const breakPointMedium = uikit_1.default.util.getCssVar("breakpoint-l");
/*
 * 画面のサイズ変動があった時に高さを再計算する
 */
const setFillHeight = () => {
    const vh = window.innerHeight;
    let headerHeight = (0, util_1.getCssPropertyValue)("--project-header-height-s");
    if (window.matchMedia(`(min-width: ${breakPointMedium})`).matches) {
        headerHeight = (0, util_1.getCssPropertyValue)("--project-header-height-m");
    }
    document.documentElement.style.setProperty("--project-header-vh-s", `calc(${vh}px - ${headerHeight})`);
};
window.addEventListener("load", setFillHeight);
window.addEventListener("resize", setFillHeight);
/*
 * Navbar
 */
// Reset
window.addEventListener("load", navbar_1.navbarReset);
window.addEventListener("resize", navbar_1.navbarReset);
// Toggle button
const navToggleElement = document.querySelector(".js-nav-toggle");
if (navToggleElement) {
    navToggleElement.addEventListener("click", { handleEvent: navbar_1.navToggle });
    navToggleElement.addEventListener("keydown", { handleEvent: navbar_1.navToggle });
}
/*
 * Link to phone
 */
window.addEventListener("load", link_to_phone_1.linkToPhone);
/*
 * Scroll
 */
const scrollElements = document.querySelectorAll(".js-scroll");
if (scrollElements.length > 0) {
    window.addEventListener("load", scroll_1.scroll);
    window.addEventListener("resize", scroll_1.scroll);
}
/*
 * Show / hide back to top
 */
window.addEventListener("scroll", scroll_1.showHideBackToTop);
/*
 * Scroll from external link
 */
window.addEventListener("load", scroll_1.externalLinkScroll);
window.addEventListener("hashchange", scroll_1.externalLinkScroll);
/*
 * Swiper
 */
const swiper = new swiper_1.default(".js-home-hero-slide", {
    effect: "fade",
    loop: true,
    speed: 2000,
    autoplay: {
        delay: 3000,
        disableOnInteraction: false,
    },
    allowTouchMove: false,
    navigation: false,
});
swiper.autoplay.stop();
/*
 * Loading
 */
window.addEventListener("DOMContentLoaded", () => {
    (0, loading_1.loading)(swiper);
});
